import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDJSjQ5G21MrzUopJS3ZuH0F2UWmjPVSpU",
    authDomain: "ofertiz-afca8.firebaseapp.com",
    projectId: "ofertiz-afca8",
    storageBucket: "ofertiz-afca8.firebasestorage.app",
    messagingSenderId: "383660067936",
    appId: "1:383660067936:web:5c4fff0b38e91fe99b4705"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);
export default app;
